/**
 * Demo mode helpers.
 *
 * For specific demo personas (today: just Margot) we short-circuit slow
 * real-backend interactions with pre-baked fixtures so live demos stay
 * snappy. The /conversations-sync endpoint takes ~20s cold; that's death
 * for a 6-minute demo. Fixtures load instantly and look identical.
 *
 * Detection: viewing-as a demo user, or actually logged in as one.
 */
import useAuth from '../hooks/useAuth';

const DEMO_USER_IDS = new Set(['user_margot']);
const DEMO_EMAILS = new Set(['margot@maxboyd.ai', 'margot@test.com']);

export const useIsDemoUser = () => {
  const { account, viewingAs } = useAuth();
  if (viewingAs?.user_id && DEMO_USER_IDS.has(viewingAs.user_id)) return true;
  if (viewingAs?.email && DEMO_EMAILS.has(viewingAs.email)) return true;
  if (account?.email && DEMO_EMAILS.has(account.email)) return true;
  return false;
};

const norm = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

// Look up a fixture by trying exact key match, then "contains" match against
// the normalized requirement/course/prompt text. Tolerant on purpose so a
// slightly-rephrased fixture still hits.
export const findFixture = (fixtures, key) => {
  if (!fixtures || !key) return null;
  const want = norm(key);
  if (fixtures[key]) return fixtures[key];
  // Direct normalized match
  for (const [k, v] of Object.entries(fixtures)) {
    if (norm(k) === want) return v;
  }
  // Contains match either way
  for (const [k, v] of Object.entries(fixtures)) {
    const kn = norm(k);
    if (want.includes(kn) || kn.includes(want)) return v;
  }
  return null;
};
